import React from 'react';
import PageTitle from '../../layouts/PageTitle';

const MenuItem = () => {
    return (
        <div className='menuItem'>

            <PageTitle
                title="Reports"
                subtitle="Menu Performance"
            />

            <div className='date_select'>
                <select className='border-0' name="week" id="week" style={{ width: '60px' }}>
                    <option value="" selected>Today</option>
                    <option value="">Yesterday</option>
                    <option value="">This week</option>
                    <option value="">Last week</option>
                    <option value="">Custom</option>
                </select>
            </div>
            <div className='card-header top-portion mt-2' style={{ padding:'0px' }}>
                <div className="row w-100 ml-1">
                    <div className="col-md-6 col-lg-6">
                        <h3>Menu items by count </h3>
                    </div>
                    <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                        <i className="mdi mdi-download mdi-24px"></i>
                        <i className="mdi mdi-send ml-3"></i>
                    </div>
                </div>
            </div>
            <div className='card-header reportmenutop-portion' style={{ padding: '0 0' }}>
                <div className="row w-100 align-items-center ms-1">
                    <div className="col-md-6 col-lg-6">
                        <span>Dish</span>
                    </div>
                    <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                        <span>Order amount/Revenue</span>
                    </div>
                </div>
            </div>
            <div className='card-header reportmenutop-portion'>
                <div className="row w-100 align-items-center ms-1">
                    <div className="col-md-6 col-lg-6">
                        <b>Product A</b>
                    </div>
                    <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                        <ul>
                            <li className='fs-4 count text-right'>45</li>
                            <li className='mt-1'>SGD 355.50</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='card-header reportmenutop-portion'>
                <div className="row w-100 align-items-center ms-1">
                    <div className="col-md-6 col-lg-6">
                        <b>Product B</b>
                    </div>
                    <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                        <ul>
                            <li className='fs-4 count text-right'>48</li>
                            <li> SGD 355.50</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='card-header reportmenutop-portion'>
                <div className="row w-100 align-items-center ms-1">
                    <div className="col-md-6 col-lg-6">
                        <b>Product C</b>
                    </div>
                    <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                        <ul>
                            <li className='fs-4 count text-right'>12</li>
                            <li> SGD 355.50</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='card-header reportmenutop-portion'>
                <div className="row w-100 align-items-center ms-1">
                    <div className="col-md-6 col-lg-6">
                        <b>Product D</b>
                    </div>
                    <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                        <ul>
                            <li className='fs-4 count text-right'>34</li>
                            <li> SGD 355.50</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='card-header reportmenutop-portion'>
                <div className="row w-100 align-items-center ms-1">
                    <div className="col-md-6 col-lg-6">
                        <b>Product E</b>
                    </div>
                    <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                        <ul>
                            <li className='fs-4 count text-right'>4</li>
                            <li> SGD 355.50</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MenuItem;